(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
      this.initRhovive();
    }

    // Rhovive additions: the Shop pill jumps to the buy box on the homepage (only when that section
    // exists); the header turns into a flush band once it reaches the top of the screen; the search panel;
    // a tap on an in-page link inside the mobile menu closes the menu, and "Subscribe & save" picks the
    // subscription in this page's buy box instead of reloading the page.
    initRhovive() {
      const shop = this.querySelector('[data-rv-home-anchor]');
      if (shop) {
        const anchor = shop.getAttribute('data-rv-home-anchor');
        try {
          if (anchor.charAt(0) === '#' && document.querySelector(anchor)) shop.setAttribute('href', anchor);
        } catch (e) {}
      }

      // Stuck: the header section is at the top of the screen and the page is scrolled (at the very top the
      // bar floats, even when there's no announcement bar above it). rv-chrome.css does the rest.
      let ticking = false;
      const stick = () => {
        ticking = false;
        const stuck = window.scrollY > 0 && this.header.getBoundingClientRect().top <= 0.5;
        if (stuck !== this.classList.contains('rv-header--stuck')) this.classList.toggle('rv-header--stuck', stuck);
      };
      this.onRvScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(stick);
      };
      window.addEventListener('scroll', this.onRvScroll, { passive: true });
      stick();

      this.initRvSearch();
      this.initRvGlide();

      const drawer = this.querySelector('header-drawer');
      if (!drawer) return;
      drawer.addEventListener('click', (event) => {
        const link = event.target.closest('a[href]');
        if (!link || !drawer.contains(link)) return;
        const details = drawer.querySelector('details');
        if (!details || !details.hasAttribute('open')) return;
        let url;
        try {
          url = new URL(link.href, window.location.href);
        } catch (e) {
          return;
        }
        const samePage = url.pathname === window.location.pathname;
        const summary = details.querySelector('summary');
        // "Subscribe & save": any page with a buy box (home, PDP) picks the subscription right here
        const sub =
          link.hasAttribute('data-rv-plan-link') &&
          document.querySelector('rv-buy-box [data-rv-plan][value="sub"]:not([hidden])');
        if (sub) {
          event.preventDefault();
          drawer.closeMenuDrawer(event, summary);
          document.dispatchEvent(new CustomEvent('rv:plan-pick', { detail: { plan: 'sub' } }));
          // land on the plan choice itself (the subscription, now picked, and Add right under it)
          const plan = sub.closest('fieldset');
          const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (plan && !plan.hidden) {
            plan.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
          } else {
            let target = null;
            try {
              target = samePage && url.hash ? document.querySelector(url.hash) : null;
            } catch (e) {}
            (target || sub.closest('rv-buy-box')).scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
          }
          sub.focus({ preventScroll: true });
          return;
        }
        if (samePage && url.hash) drawer.closeMenuDrawer(event, summary);
      });
    }

    // Section links glide (rv-base.css: scroll-behavior smooth). A link like "/#reviews" on "/?utm_source=…" (or a
    // preview address) has a different query, so the browser would reload the page instead: take those over, glide
    // to the section and keep the address's query. Same-query links stay native.
    initRvGlide() {
      if (window.rvGlideBound) return;
      window.rvGlideBound = true;
      document.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const a = event.target.closest && event.target.closest('a[href*="#"]');
        if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
        let url;
        try {
          url = new URL(a.href, window.location.href);
        } catch (e) {
          return;
        }
        const here = window.location;
        if (url.origin !== here.origin || url.pathname !== here.pathname || url.search === here.search || url.hash.length < 2) return;
        let target = null;
        try {
          target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
        } catch (e) {}
        if (!target) return;
        event.preventDefault();
        history.pushState(null, '', here.pathname + here.search + url.hash);
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
      });
    }

    // The search panel: a native modal <dialog> (sections/header.liquid). The magnifier links stay real links
    // to /search for modified clicks (new tab) and when this script doesn't run.
    initRvSearch() {
      const dlg = document.querySelector('dialog[data-rv-search]');
      const openers = this.querySelectorAll('[data-rv-search-open]');
      if (!dlg || typeof dlg.showModal !== 'function' || !openers.length) return;
      const root = document.documentElement;
      const panel = dlg.firstElementChild;
      const input = dlg.querySelector('input[type="search"]');
      let opener = null;
      let timer = 0;
      let downOnBackdrop = false;

      const finish = () => {
        clearTimeout(timer);
        panel.removeEventListener('transitionend', onEnd);
        if (dlg.open) dlg.close();
      };
      const onEnd = (event) => {
        if (event.target === panel) finish();
      };
      const close = () => {
        if (!dlg.open || dlg.classList.contains('is-closing')) return;
        dlg.classList.remove('is-open');
        dlg.classList.add('is-closing');
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return finish();
        panel.addEventListener('transitionend', onEnd);
        timer = setTimeout(finish, 450);
      };
      const open = (from) => {
        opener = from;
        clearTimeout(timer);
        panel.removeEventListener('transitionend', onEnd);
        dlg.classList.remove('is-closing');
        if (!dlg.open) dlg.showModal();
        root.classList.add('rv-search-open');
        if (input) input.focus({ preventScroll: true });
        requestAnimationFrame(() => requestAnimationFrame(() => dlg.classList.add('is-open')));
      };

      dlg.addEventListener('close', () => {
        dlg.classList.remove('is-open', 'is-closing');
        root.classList.remove('rv-search-open');
        if (opener && opener.isConnected) opener.focus({ preventScroll: true });
        opener = null;
      });
      // Esc: the same slide-out as the close button
      dlg.addEventListener('cancel', (event) => {
        event.preventDefault();
        close();
      });
      // a tap on the dimmed page under the panel (only when the press started there too, so a text selection
      // dragged out of the field doesn't close it)
      dlg.addEventListener('pointerdown', (event) => {
        downOnBackdrop = event.target === dlg;
      });
      dlg.addEventListener('click', (event) => {
        if (event.target === dlg && downOnBackdrop) close();
      });
      const x = dlg.querySelector('[data-rv-search-close]');
      if (x) x.addEventListener('click', close);
      openers.forEach((a) =>
        a.addEventListener('click', (event) => {
          if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          open(a);
        })
      );
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.onRvScroll) window.removeEventListener('scroll', this.onRvScroll);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
